<script>
	import OrgLogo from 'components/svg/org-logo.vue';
	import OutboundLink from 'components/outbound-link.vue';
	import AwardsList from 'components/nav/awards-list.vue';
	import analyticsUtilities from 'utilities/analyticsUtilities';

	export default {
		components: {
			'org-logo': OrgLogo,
			'outbound-link': OutboundLink,
			'awards-list': AwardsList
		},
		data() {
			return {
				menus: [
					{
						title: 'Organization',
						items: [
							{
								text: 'Team',
								url: 'https://about.readworks.org/our-team.html',
								outboundLink: 'FOOTER_TEAM'
							},
							{
								text: 'Board',
								url: 'https://about.readworks.org/our-team.html#board',
								outboundLink: 'FOOTER_BOARD'
							},
							{
								text: 'Advisors',
								url: 'https://about.readworks.org/our-team.html#advisors',
								outboundLink: 'FOOTER_ADVISORS'
							},
							{
								text: 'Core Values',
								url: 'https://about.readworks.org/corevalues.html',
								outboundLink: 'FOOTER_VALUES'
							},
							{
								text: 'DEI Statement',
								url: 'https://about.readworks.org/dei.html',
								outboundLink: 'FOOTER_DEI'
							},
							{
								text: 'Accessibility Statement',
								url: 'https://about.readworks.org/accessibility-statement.html',
								outboundLink: 'FOOTER_A11Y_STATEMENT'
							},
							{
								text: 'Privacy Policy',
								url: '/privacy',
								homepageClick: 'FOOTER_PRIVACY'
							},
							{
								text: 'Terms',
								url: '/terms',
								homepageClick: 'FOOTER_TERMS'
							},
							{
								text: 'Partners',
								url: 'https://about.readworks.org/our-partners.html',
								outboundLink: 'FOOTER_PARTNERS'
							},
							{
								text: 'Finances',
								url: 'https://about.readworks.org/our-financials.html',
								outboundLink: 'FOOTER_FINANCES'
							},
							{
								text: 'Careers',
								url: 'https://about.readworks.org/careers.html',
								outboundLink: 'FOOTER_CAREERS'
							}
						]
					},
					{
						title: 'Impact',
						items: [
							{
								text: 'About',
								url: 'https://about.readworks.org/',
								outboundLink: 'FOOTER_ABOUT'
							},
							{
								text: 'Our Story',
								url: 'https://about.readworks.org/ourstory.html',
								outboundLink: 'FOOTER_STORY'
							},
							{
								text: 'Research',
								url: 'https://about.readworks.org/the-research.html',
								outboundLink: 'FOOTER_RESEARCH'
							}
						]
					},
					{
						title: 'Resources',
						items: [
							{
								text: 'Teacher Guide',
								url: '/teacher-guide',
								homepageClick: 'FOOTER_TEACHER_GUIDE'
							},
							{
								text: 'Webinars',
								url: '/webinars',
								homepageClick: 'FOOTER_WEBINARS'
							},
							{
								text: 'Tools',
								url: '/teacher-guide/differentiation-tools.html',
								homepageClick: 'FOOTER_TOOLS'
							},
							{
								text: 'Content',
								url: '/find-content',
								homepageClick: 'FOOTER_FIND_CONTENT'
							}
						]
					},
					{
						title: 'Other',
						items: [
							{
								text: 'Blog',
								url: 'https://about.readworks.org/blog',
								outboundLink: 'FOOTER_BLOG'
							},
							{
								text: 'Press',
								url: 'https://about.readworks.org/press.html',
								outboundLink: 'FOOTER_PRESS'
							},
							{
								text: 'Licensing',
								url: 'https://about.readworks.org/licensing.html',
								outboundLink: 'FOOTER_LICENSING'
							},
							{
								text: 'Awards',
								url: 'https://about.readworks.org/awards.html',
								outboundLink: 'FOOTER_AWARDS'
							},
							{
								text: 'Donate',
								url: 'https://about.readworks.org/donate.html',
								outboundLink: 'FOOTER_DONATE'
							},
							{
								text: 'Contact',
								url: 'https://help.readworks.org',
								outboundLink: 'FOOTER_CONTACT'
							}
						]
					},
					{
						title: 'Connect With Us',
						class: 'icons',
						items: [
							{
								label: 'Facebook',
								icon: 'fa-brands fa-facebook',
								url: 'https://www.facebook.com/ReadWorks/',
								outboundLink: 'FOOTER_FACEBOOK'
							},
							{
								label: 'Twitter',
								icon: 'fa-brands fa-twitter',
								url: 'https://www.twitter.com/ReadWorks/',
								outboundLink: 'FOOTER_TWITTER'
							},
							{
								label: 'Pinterest',
								icon: 'fa-brands fa-pinterest',
								url: 'https://www.pinterest.com/readworks/',
								outboundLink: 'FOOTER_PINTEREST'
							},
							{
								label: 'Email',
								icon: 'fa-solid fa-envelope',
								url: 'mailto:help@readworks.org',
								homepageClick: 'FOOTER_EMAIL',
								target: '_blank'
							},
							{
								label: 'LinkedIn',
								icon: 'fa-brands fa-linkedin',
								url: 'https://www.linkedin.com/company/readworks/',
								outboundLink: 'FOOTER_LINKEDIN'
							},
							{
								label: 'Instagram',
								icon: 'fa-brands fa-instagram',
								url: 'https://www.instagram.com/readworks/',
								outboundLink: 'FOOTER_INSTAGRAM'
							},
							{
								label: 'Vimeo',
								icon: 'fa-brands fa-vimeo',
								url: 'https://vimeo.com/readworks',
								outboundLink: 'FOOTER_VIMEO'
							},
							{
								label: 'YouTube',
								icon: 'fa-brands fa-youtube',
								url: 'https://www.youtube.com/@readworks1397',
								outboundLink: 'FOOTER_YOUTUBE'
							}
						]
					}
				]
			};
		},
		methods: {
			homepageClick(loc) {
				if (loc) {
					analyticsUtilities.fireEvent(analyticsUtilities.events.HOMEPAGE_CLICK, {
						loc
					});
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.unauth-footer {
		--footer-curve-height: 3rem;
		--footer-logo-height: 2.5rem;
		position: relative;
		background-color: $c-blue-accent-1;
		color: $c-white;
		overflow: hidden;

		@include media(sm, max) {
			text-align: center;
		}

		@include media(med) {
			--footer-curve-height: 6rem;
			--footer-logo-height: 3.125rem;
		}

		&::before {
			content: '';
			position: relative;
			display: block;
			left: -2.5%;
			width: 105%;
			height: var(--footer-curve-height);
			background-color: $c-white;
			clip-path: ellipse(60% 100% at top center);
		}

		.logo-container {
			position: absolute;
			top: calc(var(--footer-curve-height) - (var(--footer-logo-height) / 2));
			width: 100%;
			display: flex;
			justify-content: center;
		}

		.logo-pill {
			padding: 0.5rem 0.75rem;
			border-radius: 2rem;
			background-color: $c-white;
			height: var(--footer-logo-height);

			@include media(med) {
				padding: 0.75rem 1rem;
			}
		}

		.org-logo {
			fill: $c-blue;
			height: 100%;
		}

		.wrapper {
			margin-top: 2rem;

			@include media(med) {
				margin-top: 4rem;
			}
		}

		.menu-wrapper {
			display: grid;
			grid-template-columns: repeat(auto-fill, 12rem);
			justify-content: space-between;

			@include media(sm, max) {
				justify-content: center;
				grid-template-columns: 12rem;
			}

			@include media(med) {
				display: flex;
				flex-flow: column wrap;
				align-content: space-between;
				max-height: 550px;
			}
		}

		.footer-heading {
			font-weight: 500;
			margin-bottom: 0.5rem;
		}

		.footer-section {
			width: 12rem;
		}

		.footer-menu {
			&.icons {
				display: grid;
				grid-template-columns: repeat(4, 2rem);
				grid-auto-rows: 3rem;
				gap: 0 1rem;

				a {
					font-size: 1.75rem;
					transition: font-size 0.2s;

					&:hover {
						font-size: 1.875rem;
					}
				}
			}

			li {
				padding: 0.25rem 0;

				@include media(med) {
					padding: 0.5rem 0;
				}
			}
		}

		.footer-link {
			display: block;
			color: $c-white;

			&:hover {
				color: $c-babyblue;
				text-decoration: underline;
			}
		}
	}
</style>
<template>
	<footer class="unauth-footer">
		<div class="logo-container">
			<div class="logo-pill">
				<org-logo></org-logo>
			</div>
		</div>
		<div class="wrapper">
			<div class="menu-wrapper">
				<section
					v-for="(menu, index) in menus"
					:key="menu.title"
					class="footer-section">
					<h2
						class="footer-heading"
						:id="`footer-heading-${index}`">
						{{ menu.title }}
					</h2>
					<ul
						class="footer-menu list-unstyled"
						:class="menu.class"
						:aria-labelledby="`footer-heading-${index}`">
						<li
							v-for="item in menu.items"
							:key="item.url">
							<outbound-link
								class="footer-link"
								:href="item.url"
								:data-outbound-link="item.outboundLink"
								:aria-label="item.label"
								:target="item.outboundLink ? '_blank' : item.target || '_self'"
								@click.native="homepageClick(item.homepageClick)">
								<span v-if="item.text">{{ item.text }}</span>
								<i
									v-if="item.icon"
									:class="item.icon"></i>
							</outbound-link>
						</li>
					</ul>
				</section>
			</div>
			<section class="awards">
				<h2 class="footer-heading">Our Awards</h2>
				<awards-list></awards-list>
			</section>
		</div>
	</footer>
</template>
